import { create } from "zustand";
import { persist } from "zustand/middleware";

interface NSFWState {
  isNSFWEnabled: boolean;
  isAgeVerified: boolean;
  setNSFWEnabled: (enabled: boolean) => void;
  setAgeVerified: (verified: boolean) => void;
}

const useNSFWStore = create<NSFWState>()(
  persist(
    (set) => ({
      isNSFWEnabled: false,
      isAgeVerified: false,
      setNSFWEnabled: (enabled) => set({ isNSFWEnabled: enabled }),
      setAgeVerified: (verified) => set({ isAgeVerified: verified }),
    }),
    {
      name: "nsfw-storage", // unique name for localStorage key
    },
  ),
);

export default useNSFWStore;
